import { Icon, IconDisplay, IconSize } from "@components/Icon";
import { Popover } from "@components/Popover";
import { css } from "@emotion/react";
import React from "react";

import { spacing, verticalStackCss } from "src/theme/spacing";

const POPOVER_WIDTH = "235px";

export const PublicAmountsIcon = ({ size }: { size: IconSize }) => {
  const icon = (
    <Icon
      iconImport={() => import("./Icon/icons/PublicAmountsIcon")}
      display={IconDisplay.CURRENT_COLOR}
      size={size}
    />
  );

  const message =
    "This person has chosen to be a Transparent Supporter with public donation amounts";
  const publicInfoPopoverContent = (
    <div
      css={[
        verticalStackCss.xxs,
        css`
          align-items: center;
          max-width: ${POPOVER_WIDTH};
        `,
      ]}
    >
      {icon}
      <span
        css={css`
          width: ${POPOVER_WIDTH};
        `}
      >
        {message}
      </span>
    </div>
  );
  return (
    <Popover
      placement={"bottom"}
      content={publicInfoPopoverContent}
      css={css`
        display: inline-block;
        padding-bottom: ${spacing.xxxs};
      `}
    >
      {icon}
    </Popover>
  );
};
